import { render, staticRenderFns } from "./DashboardPolizas.vue?vue&type=template&id=6517aa98"
import script from "./DashboardPolizas.vue?vue&type=script&lang=js"
export * from "./DashboardPolizas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports